var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPodUploadModelTimeQuarterPass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.88709 1.75012C4.76231 1.79675 4.63959 1.84761 4.51911 1.90252M12.0866 9.5091C12.1462 9.38006 12.2011 9.24841 12.2512 9.11441M10.7922 11.2962C10.8924 11.2027 10.9892 11.1057 11.0824 11.0053M8.9081 12.4673C9.02132 12.4246 9.1328 12.3785 9.24246 12.3289M7.09224 12.8299C6.95755 12.8346 6.82192 12.8346 6.68717 12.8299M4.54384 12.332C4.6493 12.3794 4.75647 12.4238 4.86522 12.465M2.72689 11.0373C2.80663 11.1218 2.88891 11.2039 2.97361 11.2834M1.53698 9.13775C1.58066 9.25307 1.62796 9.36665 1.67874 9.4783M1.1708 7.29488C1.16702 7.17349 1.16703 7.05134 1.1708 6.92977M1.53275 5.09679C1.57566 4.98275 1.62211 4.87045 1.67196 4.76001M2.71725 3.19634C2.80163 3.10645 2.88888 3.0193 2.97886 2.93501",
    stroke: "#414E5D",
    strokeWidth: 0.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.875 7.00012C7.875 7.48336 7.48323 7.87512 7 7.87512C6.51677 7.87512 6.125 7.48336 6.125 7.00012C6.125 6.51689 6.51677 6.12512 7 6.12512M7.875 7.00012C7.875 6.51689 7.48323 6.12512 7 6.12512M7.875 7.00012H9.33333M7 6.12512V3.50012",
    stroke: "#0020F5",
    strokeWidth: 0.875,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8333 7.00008C12.8333 3.77842 10.2216 1.16675 7 1.16675",
    stroke: "#414E5D",
    strokeWidth: 0.875,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPodUploadModelTimeQuarterPass);
export default __webpack_public_path__ + "static/media/pod-upload-model-time-quarter-pass.44e0dfd7783e0e0b83566e0915936a4b.svg";
export { ForwardRef as ReactComponent };